import { render } from "./UnsubscribeNewsletter.vue?vue&type=template&id=3dfeb3e4"
import script from "./UnsubscribeNewsletter.vue?vue&type=script&lang=js"
export * from "./UnsubscribeNewsletter.vue?vue&type=script&lang=js"

import "./UnsubscribeNewsletter.vue?vue&type=style&index=0&id=3dfeb3e4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__